<template>
  <div class="layout-app" :class="current_mode" :dir="$page.props.dir">
      <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:h-screen md:flex md:flex-col">
        <div class="md:flex md:shrink-0 ">
          <div class="flex items-center justify-between md:shrink-0 md:py-2 md:w-60 md:justify-center sidebar-left-top">
              <Link class="mt-1" href="/">
                  <logo class="help-desk-logo" />
              </Link>
              <dropdown class=" md:hidden" className="small-menu" placement="bottom-end">
                  <template #default>
                      <svg class="w-6 h-6 mobile-menu-selector" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
                  </template>
                  <template #dropdown>
                      <div class="px-8 py-4 mt-2 rounded shadow-lg bg-hd-sidebar">
                          <main-menu :auth="auth" />
                      </div>
                  </template>
              </dropdown>
          </div>
          <div class="flex items-center w-full p-4 text-sm bg-white md:py-2 md:pr-12 md:pl-8 justify-first top_bar">
              <div class="placement-top-left">
                  <div class="mt-1 welcome_text">{{ generateGreetings() }} <span>{{ $page.props.auth.user.first_name }}!</span></div>
                  <div class="display-time">
                      <span class="time">{{ time }} </span>
                  </div>
              </div>
              <div class="placement-top-right">
                  <dropdown class="mt-1 rtl:ml-2 language_menu_wrapper" placement="bottom-end">
                      <template #default>
                      <div class="flex items-center cursor-pointer group language_menu">
                          <div class=" font-bold mr-1 rtl:mr-0 whitespace-nowrap w-[7rem]">
                              <icon class="w-5 h-5" :name="selected_language.code" /> <span class="rtl:mr-[6px]">{{ selected_language.name }}</span>
                          </div>
                          <icon class="w-5 h-5 drop-down-caret-icon" name="cheveron-down" />
                      </div>
                      </template>
                      <template #dropdown>
                      <div class="py-2 text-sm rounded shadow-xl language_menu_list">
                          <Link v-for="language in languages_except_selected" :key="language.code" class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('language', [language.code])">
                              <icon class="w-5 h-5" :name="language.code" /> <span class="lang_name rtl:mr-[6px]">{{ language.name }}</span>
                          </Link>
                      </div>
                      </template>
                  </dropdown>
                  <dropdown class="mt-1 select_user" placement="bottom-end">
                      <template #default>
                          <div class="flex items-center cursor-pointer group">
                              <div class="mr-1 whitespace-nowrap">
                                  <img v-if="$page.props.auth.user.photo" class="user_photo" :alt="$page.props.auth.user.first_name" :src="$page.props.auth.user.photo" />
                                  <img v-else src="/images/svg/profile.svg" class="w-5 h-5" alt="user profile" />
                                  <span>{{ $page.props.auth.user.first_name }}</span>
                                  <span class="hidden md:inline">{{ $page.props.auth.user.last_name }}</span>
                              </div>
                              <icon class="w-5 h-5 drop-down-caret-icon" name="cheveron-down" />
                          </div>
                      </template>
                      <template #dropdown>
                          <div class="text-sm bg-white rounded shadow-xl">
                              <Link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('users.edit.profile')">{{ __('Edit Profile') }}</Link>
                              <Link class="block w-full px-6 py-2 text-left hover:bg-indigo-500 hover:text-white" :href="route('logout')" method="delete" as="button">{{ __('Logout') }}</Link>
                          </div>
                      </template>
                  </dropdown>
              </div>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <main-menu class="hidden overflow-y-auto md:block sidebar shrink-0 md:w-60" />
          <div class="md:flex-1 md:overflow-y-auto" scroll-region>
            
            <flash-messages />
            <!-- <password-change-banner /> -->
              <div class="sec-cont">
                  <slot />
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import PasswordChangeBanner from '@/Components/PasswordChangeBanner'
import { Link } from '@inertiajs/inertia-vue3'
import moment from 'moment'

export default {
    components: {
        Dropdown,
        FlashMessages,
        Icon,
        Logo,
        Link,
        MainMenu,
        PasswordChangeBanner,
    },
    props: {
        title: String,
    },
    data() {
        return{
            time: '',
            current_mode: 'light',
            modes: ['dark', 'light'],
            edit_route: '',
            unreadChatCount: 0,
            originalTitle: '',
            titleFlashInterval: null,
            audioCtx: null,
        }
    },
    computed: {
        selected_language() {
            return this.$page.props.languages.find(language => language.code === this.$page.props.locale)
        },
        languages_except_selected(){
            return this.$page.props.languages.filter(language => language.code !== this.$page.props.locale)
        }
    },
    methods:{
        generateGreetings(){
            const currentHour = this.moment().format('HH')
            if (currentHour >= 3 && currentHour < 12){
                return 'Good Morning'
            } else if (currentHour >= 12 && currentHour < 15){
                return 'Good Noon'
            }else if (currentHour >= 15 && currentHour < 18){
                return 'Good Afternoon'
            }   else if (currentHour >= 18 && currentHour < 20){
                return 'Good Evening'
            } else {
                return 'Hello'
            }
        },
        switchMode(){
            this.current_mode = this.current_mode === 'light' ? 'dark' : 'light'
            localStorage.setItem('current_mode', this.current_mode)
        },
        detectCurrentUrl(){
            const url = this.$page.url;
            const splitUrl = url.split('/');
            let editString = ['edit', 'create'].includes(url.substring(url.lastIndexOf("/") + 1));
            if(!editString){
                editString = splitUrl[splitUrl.length - 2] === 'tickets';
            }
            let editRoute = url.split('/')[2]
            if(['settings','front_pages'].includes(editRoute)){
                editRoute = url.split('/')[3];
            }
            this.edit_route = editString? editRoute : '';
        },
        isViewingConversation(conversationId) {
            const url = this.$page.url || '';
            const match = url.match(/\/chat\/(\d+)/);
            if (!match) return false;
            return parseInt(match[1]) === parseInt(conversationId);
        },
        playBeep() {
            try {
                if (!this.audioCtx) {
                    const AC = window.AudioContext || window.webkitAudioContext;
                    if (!AC) return;
                    this.audioCtx = new AC();
                }
                if (this.audioCtx.state === 'suspended') {
                    this.audioCtx.resume();
                }
                const ctx = this.audioCtx;
                const playTone = (freq, startOffset, duration) => {
                    const osc = ctx.createOscillator();
                    const gain = ctx.createGain();
                    osc.type = 'sine';
                    osc.frequency.value = freq;
                    osc.connect(gain);
                    gain.connect(ctx.destination);
                    const t0 = ctx.currentTime + startOffset;
                    gain.gain.setValueAtTime(0.0001, t0);
                    gain.gain.exponentialRampToValueAtTime(0.25, t0 + 0.01);
                    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
                    osc.start(t0);
                    osc.stop(t0 + duration + 0.02);
                };
                playTone(880, 0, 0.15);
                playTone(1175, 0.16, 0.18);
            } catch (e) {
                // Audio playback may be blocked until first user interaction; ignore.
            }
        },
        flashTitle() {
            if (this.titleFlashInterval) return;
            const newTitle = `(${this.unreadChatCount}) New message`;
            let toggled = false;
            this.titleFlashInterval = window.setInterval(() => {
                document.title = toggled ? this.originalTitle : newTitle;
                toggled = !toggled;
            }, 1000);
        },
        updateTitleFlash() {
            if (this.titleFlashInterval) {
                clearInterval(this.titleFlashInterval);
                this.titleFlashInterval = null;
            }
            if (this.unreadChatCount > 0 && document.hidden) {
                this.flashTitle();
            } else if (this.unreadChatCount > 0 && !document.hidden) {
                document.title = `(${this.unreadChatCount}) ${this.originalTitle}`;
            } else {
                document.title = this.originalTitle;
            }
        },
        clearChatNotifications() {
            this.unreadChatCount = 0;
            if (this.titleFlashInterval) {
                clearInterval(this.titleFlashInterval);
                this.titleFlashInterval = null;
            }
            document.title = this.originalTitle;
        },
        stopTitleFlash() {
            if (this.titleFlashInterval) {
                clearInterval(this.titleFlashInterval);
                this.titleFlashInterval = null;
            }
            if (this.unreadChatCount > 0) {
                document.title = `(${this.unreadChatCount}) ${this.originalTitle}`;
            } else {
                document.title = this.originalTitle;
            }
        },
        handleVisibilityChange() {
            if (!document.hidden) {
                // Tab is visible again: stop the flashing alert, but keep the
                // unread count prefix until user actually opens a conversation.
                this.stopTitleFlash();
            }
        },
        handleIncomingChatMessage(e) {
            if (!e || !e.message) return;
            const msg = e.message;
            // Don't notify if the user is the sender (shouldn't happen on user.{id}, but safety).
            if (this.$page.props.auth && this.$page.props.auth.user && msg.user_id === this.$page.props.auth.user.id) {
                return;
            }
            // Don't notify if user is actively viewing this conversation in a visible tab.
            if (!document.hidden && this.isViewingConversation(msg.conversation_id)) {
                return;
            }
            this.unreadChatCount += 1;
            this.playBeep();
            this.updateTitleFlash();
        },
        setupChatNotifications() {
            if (!this.$page.props.auth || !this.$page.props.auth.user || !window.Echo) return;
            const userId = this.$page.props.auth.user.id;
            const channel = window.Echo.channel(`user.${userId}`);
            // Bind both name variants to be safe (with/without leading dot).
            channel.listen('.MessageSent', this.handleIncomingChatMessage);
            channel.listen('MessageSent', this.handleIncomingChatMessage);
        },
    },
    updated() {
        this.detectCurrentUrl()
        console.log(this.selected_language);
        // If user navigated into a chat conversation, clear the alert.
        if (/\/chat\/\d+/.test(this.$page.url || '')) {
            this.clearChatNotifications();
        }
    },
    created() {
        this.moment = moment;
        let vm = this
        if(localStorage.getItem('current_mode')){
            this.current_mode = localStorage.getItem('current_mode')
        }
        vm.time = vm.moment().format('MMMM Do YYYY, h:mm A')
        window.setInterval(function () {
            vm.time = vm.moment().format('MMMM Do YYYY, h:mm A')
        }, 1000)
        this.detectCurrentUrl()
    },
    mounted() {
        this.originalTitle = document.title || 'Chat';
        this.setupChatNotifications();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('focus', this.stopTitleFlash);
    },
    beforeUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('focus', this.stopTitleFlash);
        if (this.titleFlashInterval) {
            clearInterval(this.titleFlashInterval);
            this.titleFlashInterval = null;
        }
        if (this.$page.props.auth && this.$page.props.auth.user && window.Echo) {
            // Don't leave the channel here — Chat/Index.vue manages its own leave on its lifecycle.
        }
    }
}
</script>
